document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('[data-hotspot-container]');
  
  containers.forEach(container => {
    const hotspots = container.querySelectorAll('[data-hotspot]');
    const products = container.querySelectorAll('[data-product]');
    const prevButton = container.querySelector('[data-prev]');
    const nextButton = container.querySelector('[data-next]');
    let currentIndex = 0;

    function showProduct(index) {
      // Remove active class from all
      hotspots.forEach(h => h.classList.remove('active'));
      products.forEach(p => p.classList.remove('active'));

      // Add active class to current
      hotspots[index].classList.add('active');
      products[index].classList.add('active');

      currentIndex = index;
    }

    // Add click handlers to hotspots
    hotspots.forEach(hotspot => {
      hotspot.addEventListener('click', () => {
        const index = parseInt(hotspot.dataset.index);
        showProduct(index);
      });
    });

    // Add click handlers to navigation buttons
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        let index = currentIndex - 1;
        if (index < 0) index = products.length - 1;
        showProduct(index);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        let index = currentIndex + 1;
        if (index >= products.length) index = 0;
        showProduct(index);
      });
    }
  });
}); 